export const SET_SOCIAL_SECURITY_NR = 'bank-id:set-social-security-nr';
export const SET_EMAIL = 'bank-id:set-email';
export const SET_IN_PROGRESS = 'bank-id:set-in-progress';
export const SET_LOGIN_SUCCEEDED = 'bank-id:set-login-succeeded';
export const SET_ERROR = 'bank-id:set-error';
export const SET_AUTH_TYPE = 'bank-id:set-auth-type';
export const SET_ENTITY = 'bank-id:set-entity';
export const SET_CREATE_ON_AUTH = 'bank-id:set-create-on-auth';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-id/action-types.js
 **/